import { render, staticRenderFns } from "./TemplateDeletePopup.vue?vue&type=template&id=aa99c27c&lang=pug&"
import script from "./TemplateDeletePopup.vue?vue&type=script&lang=js&"
export * from "./TemplateDeletePopup.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDeletePopup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa99c27c')) {
      api.createRecord('aa99c27c', component.options)
    } else {
      api.reload('aa99c27c', component.options)
    }
    module.hot.accept("./TemplateDeletePopup.vue?vue&type=template&id=aa99c27c&lang=pug&", function () {
      api.rerender('aa99c27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/TemplateDeletePopup.vue"
export default component.exports